export default __webpack_public_path__ + "static/hero-pattern-dark2-e44aaf64d05eac6c1c7e2a53999a4f19.svg";